import { Outlet, useLocation } from 'react-router-dom';
import { AnimatePresence, motion, useReducedMotion } from 'framer-motion';
import Sidebar from './Sidebar';
import Topbar from './Topbar';
import { useSidebar } from '../contexts/SidebarContext';

export default function MainLayout() {
  const { isCollapsed, isMobile } = useSidebar();
  const location = useLocation();
  const shouldReduceMotion = useReducedMotion();

  return (
    <div className="min-h-screen">
      <Sidebar />
      <div className={`
        transition-all duration-300 ease-soft
        ${isMobile
          ? 'ml-0'
          : isCollapsed ? 'lg:ml-[76px]' : 'lg:ml-[264px]'
        }
      `}>
        <Topbar />
        <main className="mx-auto min-w-0 max-w-app px-4 py-6 sm:px-6 lg:px-8 lg:py-8">
          <AnimatePresence mode="wait" initial={false}>
            <motion.div
              key={location.pathname}
              initial={shouldReduceMotion ? false : { opacity: 0, y: 8 }}
              animate={{ opacity: 1, y: 0 }}
              exit={shouldReduceMotion ? undefined : { opacity: 0, y: -4 }}
              transition={{ duration: shouldReduceMotion ? 0 : 0.2, ease: 'easeOut' }}
            >
              <Outlet />
            </motion.div>
          </AnimatePresence>
        </main>
      </div>
    </div>
  );
}
